// Rev.ai Async API
export const REV_AI_ASYNC = 'rev_ai_async';
export const PROCESSING_SERVICES = [REV_AI_ASYNC];

// transcription_status enum values
export const STARTED = 'started';
export const READY_TO_TRANSCRIBE = 'ready_to_transcribe';
export const IN_PROGRESS = 'in_progress';
export const SUCCESS = 'success';
export const FAILED = 'failed';
export const TRANSCRIPTION_STATUS_TRIMMING = 'trimming';
export const NO_AUDIO = 'no_audio';
export const SHORT_DURATION = 'short_duration';

export const TRANSCRIPTION_STATUSES = [
  IN_PROGRESS,
  SUCCESS,
  FAILED,
  STARTED,
  READY_TO_TRANSCRIBE,
  TRANSCRIPTION_STATUS_TRIMMING,
  NO_AUDIO,
  SHORT_DURATION,
];

export type TranscriptionStatus =
  | typeof IN_PROGRESS
  | typeof SUCCESS
  | typeof FAILED
  | typeof STARTED
  | typeof READY_TO_TRANSCRIBE
  | typeof TRANSCRIPTION_STATUS_TRIMMING
  | typeof NO_AUDIO
  | typeof SHORT_DURATION;

export const TRANSCRIPT_STATUS_TOPIC = 'transcript_status_topic';
// in seconds
export const MIN_VIDEO_DURATION_TRANSCRIPTION = 5;
export const TEXT = 'text';
export const TEXT_AUDIO = 'text_audio';
export const NONE = 'none';
export const FILLER_WORD_REMOVAL_OPTIONS = [TEXT, TEXT_AUDIO, NONE];

export type FillerWordRemovalOption =
  | typeof TEXT
  | typeof TEXT_AUDIO
  | typeof NONE;

export const NUM_FILLER_WORDS_IN_VIDEO_VERSION = 'numFillerWordsInVideoVersion';

export const TRANSCRIPTION_LATEST_SCHEMA = '1.1.2';
